import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconLocationStyle0 = cosmosIconCss;

const CosmosIconLocation$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLocation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c0af6e81c1a9dcb7b9143f491365814abe14a116', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '35c858656915423a04b606c7e0ad9d22fc67fc7a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1c6b488b72cd6a0028fd51cf80b0d6b756cce519', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a6 6 0 0 0-6 6c0 2.912 1.235 4.786 4.527 9.778l1.113 1.692a.4.4 0 0 0 .67 0c.58-.898 1.108-1.705 1.589-2.44C15.88 12.477 17 10.766 17 8a6 6 0 0 0-6-6Zm0 1.5A4.51 4.51 0 0 1 15.54 8c0 2.257-.955 3.712-3.667 7.845l-.193.295-.74 1.11-.23-.35-.053-.08C7.528 12.041 6.47 10.425 6.47 8A4.51 4.51 0 0 1 11 3.5Zm0 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconLocationStyle0; }
}, [1, "cosmos-icon-location", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-location"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-location":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLocation$1);
            }
            break;
    } });
}

const CosmosIconLocation = CosmosIconLocation$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLocation, defineCustomElement };
